export default "__VITE_ASSET__2dc24b30__"